function updateSub(value) {
  document
    .querySelectorAll(
      "#bold-widget > fieldset > div > div.bsub-widget__plans-container > fieldset > div > label > input[type=radio]"
    )
    .forEach(function (element) {
      if (element.value == value) {
        element.checked = true;
        element.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  return;
}
document.addEventListener("DOMContentLoaded", function () {
  document
    .getElementById("productSelect")
    .addEventListener("change", function (event) {
      if (
        document.querySelector("#subscribe-save") == null ||
        document.querySelector("#subscribe-save").checked
      ) {
        if (event.target.children[0].selected) updateSub("5955780845");
        if (event.target.children[1].selected) updateSub("5955813613");
        if (event.target.children[2].selected) updateSub("5955944685");
      }
    });
  if (
    document.querySelector("#subscribe-save") == null ||
    document.querySelector("#subscribe-save").checked
  ) {
    if (document.getElementById("productSelect").children[0].selected)
      updateSub("5955780845");
    if (document.getElementById("productSelect").children[1].selected)
      updateSub("5955813613");
    if (document.getElementById("productSelect").children[2].selected)
      updateSub("5955944685");
  }
});
